module.exports = __webpack_public_path__ + "static/media/wk.6dc7132c.mp4";